.card {
  border-radius: var(--tfg-card-border-radius);
  border: 1px solid var(--mantine-color-gray-2);
  padding: var(--tfg-organism-padding-x) var(--tfg-organism-padding-x);
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: var(--tfg-organism-padding-y);
}
